module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multipane-resizer"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517842af","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multipane-resizer.vue
// module id = 403
// module chunks = 1